import { Box, Divider, Grid, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FeeParamsDto, getBuildPaymentRequestOTPDto, getfinalprotpdto, getMakePaymentRequestOtp, getPaymentRequestBalanceDetail, getPaymentRequestFees, selectPaymentRequestsState, setMakePaymentRequestOtpErrorClear, getCancelTransaction, setCancelTransactionErrorClear } from "../../pmui/paymentrequests/sagas/paymentrequestslice";
import { useQuery } from "../../pmui/transactions/Transactions";
import PaymentMethodModal from "./Components/PayMethodModal";
import WhiteInosio from "../../icons/whiteinosio.svg";
import PayDetailsModal from "./Components/PayDetailsModal";
import PayMethodTypeModal from "./Components/PayMethodTypeModal";
import { CreateOneTimePaymentDto, CreateTransactionDetailDto, PaymentTypeEnum, PaymentRequestStatusType } from "@inosio/payments-sdk";
import AddCardModal from "./Components/AddCardModal";
import ReviewAndSubmitModal from "./Components/ReviewAndSubmitModal";
import ThankYouForYourPaymentModal from "./Components/ThankYouForYourPaymentModal";
import ConfirmCancelModal from "./Components/ConfirmCancelModal";
import AddBankAccountModal from "./Components/AddBankAccountModal";
import CreateYourAccountWithInosioModal from "./Components/CreateAccountModal";
import AlreadyPaidModal from "./Components/AlreadyPaidModal";
import PRCancelledModal from "./Components/PRCancelledModal";
import LoginModal from "../login/LoginModal";
import CreateAnAccountModal from "../login/CreateAnAccountModal";
import { makeStyles } from "@mui/styles";
import SpinnerModal from "../Modal/SpinnerModal";
import ErrorModal from "./Components/ErrorModal";


export default function MakePayment() {
  const query = useQuery();
  const dispatch = useDispatch();
  const isOnMobileHeight = useMediaQuery("(max-height:900px)");
  const isOnMobileScreen = useMediaQuery("(max-width:600px)");
  const { PaymentRequestBalanceDetail, isPaymentRequestDetailSuccess, PaymentRequestFees, selectedPaymentOption, PrOtpDto, isFetchingOtp, isSuccessOtp, PrTransactionDto, errorCancelTransaction, isFetchingCancelTransaction, isSuccessCancelTransaction,requestDetailsError } = useSelector(selectPaymentRequestsState);
  const paymentRequestId = query.get("paymentrequestid");
  const [openPayDetailsDialog, setOpenPayDetailsDialog] = useState(true);
  const [openPayMethodTypeDialog, setOpenPayMethodTypeDialog] = useState(false);
  const [openAddCardDialog, setOpenAddCardDialog] = useState(false);
  const [openReviewAndSubmitDialog, setOpenReviewAndSumitDialog] = useState(false);
  const [openThankYouForYourPaymentDialog, setThankYouForYourPaymentDialog] = useState(false)
  const [openConfirmCancelDialog, setConfirmCancelDialog] = useState(false)
  const [openCreateYourAccountWithInosioDialog, setOpenCreateYourAccountWithInosioDialog] = useState(false)
  const [openAddBankAccountDialog, setOpenAddBankAccountDialog] = useState(false);
  const [openAlreadyPaidModalDialog, setOpenAlreadyPaidModalDialog] = useState(true);
  const [openPRCancelledModalDialog, setOpenPRCancelledModalDialog] = useState(true);
  const [openLoginModalDialog, setOpenLoginModelDialog] = useState(false);
  const [openCreateAnAccountModalDialog, setOpenCreateAnAccountModalDialog] = useState(false);
  const [isSpinnerModalOpen, setIsSpinnerModalOpen] = React.useState(false);
  const [spinnerStatus, setSpinnerStatus] = React.useState<string | null>(null);
  const [openErrorModal, setOpenErrorModal] = useState(false)


  //getting balance details
  useEffect(() => {
    if (paymentRequestId) {
      dispatch({
        type: getPaymentRequestBalanceDetail.type,
        payload: paymentRequestId
      });
    }
  }, [dispatch, paymentRequestId]);

  //getting the fees
  useEffect(() => {
    if (PaymentRequestBalanceDetail && isPaymentRequestDetailSuccess && paymentRequestId) {
      dispatch({
        type: getPaymentRequestFees.type,
        payload: {
          PayerUUID: PaymentRequestBalanceDetail.PayerUUID,
          PaymentAmount: PaymentRequestBalanceDetail.Amount,
          PropPayTypeId: PaymentRequestBalanceDetail.PropertyPaymentTypes[0].PropertyPaymentTypeID,
          PaymentRequestId: paymentRequestId,
        } as FeeParamsDto
      });
    }
  }, [dispatch, PaymentRequestBalanceDetail, isPaymentRequestDetailSuccess, paymentRequestId]);

  //setting error screen
  useEffect(() => {
    if( !paymentRequestId || requestDetailsError?.message?.length > 0 ){
      setOpenErrorModal(true)
    }
  },[paymentRequestId,requestDetailsError])




  //spinner modal states
  useEffect(() => {
    if (isFetchingOtp && !isSuccessOtp) {
      setIsSpinnerModalOpen(true)
    }
    if (isSuccessOtp && !isFetchingOtp) {
      setSpinnerStatus('start')

    }
    else if (!isFetchingOtp && !isSuccessOtp) {
      setIsSpinnerModalOpen(false)
    }
  }, [isFetchingOtp, isSuccessOtp])

  useEffect(() => {
    if (isFetchingCancelTransaction && !isSuccessCancelTransaction) {
      setIsSpinnerModalOpen(true)
    }
    if (isSuccessCancelTransaction && !isFetchingCancelTransaction) {
      setSpinnerStatus('start')
    }
    else if (!isFetchingCancelTransaction && !isSuccessCancelTransaction) {
      setIsSpinnerModalOpen(false)
    }
  }, [isFetchingCancelTransaction, isSuccessCancelTransaction, errorCancelTransaction])

  useEffect(() => {
    if (isSuccessCancelTransaction) {
      setOpenPRCancelledModalDialog(true)
    }
  }, [isSuccessCancelTransaction])

  //resetting global error states
  const resetOtpError = () => {
    dispatch({
      type: setMakePaymentRequestOtpErrorClear.type
    })
  }


  const useStyles = makeStyles((theme) => ({
    forgetText: {
      font: "14px Work Sans",
      lineHeight: "30px",
      color: "#39A2DB",
      textDecoration: "none !important",
      maxHeight: "30px !important",
      margin: "10px !important",
      marginTop: "8px !important",
      marginBottom: "27px !important",
      paddingLeft: "5px !important",
      cursor: "pointer",

    }
  })
  )
  const classes = useStyles();
  return (
    <Box sx={{ backgroundColor: "#F1F0F5", height: "100vh", display: 'flex', justifyContent: 'center', width: '100vw' }}>
      {isOnMobileHeight || openLoginModalDialog || openCreateAnAccountModalDialog || !paymentRequestId || requestDetailsError?.message?.length > 0 ? <></> :
        <Grid item display='flex' ml={6} sx={{ width: '300px', position: 'relative', top: '10%' }}>
          <img src={WhiteInosio} style={{ width: "75px", height: "75px" }} alt="logo" />
          <Typography
            sx={{
              fontFamily: "Work Sans",
              fontStyle: 'normal',
              fontWeight: 700,
              fontSize: '18px',
              lineHeight: '23px',
              color: '#14142B',
              textAlign: 'left',
              padding: '15px'
            }}>
            {PaymentRequestBalanceDetail?.CompanyName}
          </Typography>
        </Grid>}

      {/* How do you want to pay */}

      <PaymentMethodModal

        open={false}
        onTileClickIHaveAnAccount={() => {
          setOpenLoginModelDialog(true)
        }}
        onTileClickCheckoutAsGuest={() => {
          setOpenPayDetailsDialog(true)
        }}
        onTileClickCreateAnAccount={() => {
          setOpenCreateAnAccountModalDialog(true)
        }} />

      {/* Summary of Payment Request */}

      <PayDetailsModal
        open={PaymentRequestBalanceDetail?.Status === 'Pending' ? openPayDetailsDialog : false}
        onContinue={() => {
          setOpenPayDetailsDialog(false)
          setOpenAddBankAccountDialog(false)
          setOpenPayMethodTypeDialog(true)
          dispatch({
            type: getBuildPaymentRequestOTPDto.type,
            payload: {
              PayerUuid: PaymentRequestBalanceDetail?.PayerUUID,
              PaymentRequestId: PaymentRequestBalanceDetail?.PaymentRequestId,
              TransactionDetails: [{
                Amount: PaymentRequestBalanceDetail?.Amount,
                PropertyPaymentTypeId: PaymentRequestBalanceDetail?.PropertyPaymentTypes[0].PropertyPaymentTypeID,
              } as CreateTransactionDetailDto]
            } as Partial<CreateOneTimePaymentDto>
          })
        }}
        PaymentRequestDetails={PaymentRequestBalanceDetail} />

      {/* Choose Payment Method Type */}

      <PayMethodTypeModal
        open={openPayMethodTypeDialog}
        PaymentRequestFees={PaymentRequestFees}
        onClickCardIcon={() => {
          setOpenPayMethodTypeDialog(false)
          setOpenAddCardDialog(true)
        }}
        onClickBankIcon={() => {
          setOpenAddBankAccountDialog(true)
        }}
        onBackClick={() => {
          setOpenPayMethodTypeDialog(false)
          setOpenPayDetailsDialog(true)
        }}
        PaymentRequestDetails={PaymentRequestBalanceDetail}
      />

      {/* Enter Card Details */}
      <AddCardModal
        open={openAddCardDialog}
        onBackClick={() => {
          setOpenAddCardDialog(false)
          setOpenPayMethodTypeDialog(true)
        }}
        onContinue={(agreedUponFeeAmt:number) => {
          setOpenReviewAndSumitDialog(true)
          const currentTotal = PrOtpDto.TotalAmount;
          const currentFee = PrOtpDto.FeeAmount || 0;
          const currentPaymentAmt = currentTotal - currentFee;
          const newTotal =  currentPaymentAmt + agreedUponFeeAmt;

          dispatch({
            type: getBuildPaymentRequestOTPDto.type,
            payload: {
                FeeAmount: agreedUponFeeAmt,
                TotalAmount: newTotal
            } as Partial<CreateOneTimePaymentDto>
        })
          dispatch({
            type: getfinalprotpdto.type,
          })
        }}
        CardType={selectedPaymentOption}
        Fees={{CC: PaymentRequestFees.find(f=>f.PaymentType=== PaymentTypeEnum.Cc)?.FeeAmount||0, DB: PaymentRequestFees.find(f=>f.PaymentType=== PaymentTypeEnum.Db)?.FeeAmount||0}}
        CompanyName={PaymentRequestBalanceDetail?.CompanyName ?? ''}
      />

      {/* Review And Submit */}
      <ReviewAndSubmitModal
        open={openReviewAndSubmitDialog}
        onCloseIcon={() => {
          window.location.reload();
        }}
        onBackClick={() => {
          setOpenReviewAndSumitDialog(false)
          selectedPaymentOption === PaymentTypeEnum.Cc ? setOpenAddCardDialog(true) : selectedPaymentOption === PaymentTypeEnum.Db ? setOpenAddCardDialog(true) : setOpenAddBankAccountDialog(true)
          resetOtpError()
        }}
        onConfirm={() => {
          dispatch({
            type: getfinalprotpdto.type
          })
          dispatch({
            type: getMakePaymentRequestOtp.type,
            payload: PrOtpDto
          })
        }
        }
        PaymentRequestDetails={PaymentRequestBalanceDetail}
        FeeAmount={PrOtpDto?.FeeAmount ? PrOtpDto?.FeeAmount : 0}
      />

      {/* Thank you for you payment */}

      <ThankYouForYourPaymentModal
        open={openThankYouForYourPaymentDialog}
        onCancel={() => {
          setConfirmCancelDialog(true)
          dispatch({
            type: setCancelTransactionErrorClear.type
          })
        }}
        PaymentRequestDetails={PaymentRequestBalanceDetail}
        FeeAmount={PrOtpDto?.FeeAmount ? PrOtpDto?.FeeAmount : 0}
      />

      {/* Confirm Cancel */}

      <ConfirmCancelModal
        open={openConfirmCancelDialog}
        onYes={() => {
          dispatch({
            type: getCancelTransaction.type,
            payload: {
              payerUuid: PaymentRequestBalanceDetail?.PayerUUID,
              transactionUuid: PrTransactionDto?.TransactionUuid
            }
          });
          setConfirmCancelDialog(false)
        }}
        onNo={() => {
          setConfirmCancelDialog(false)
          setThankYouForYourPaymentDialog(true)
        }}
        onCloseIcon={() => {
          setConfirmCancelDialog(false)
          setThankYouForYourPaymentDialog(true)
        }}
        CompanyName={PaymentRequestBalanceDetail?.CompanyName ?? ''}
      />

      {/* Create your account with Inosio */}
      <CreateYourAccountWithInosioModal
        open={openCreateYourAccountWithInosioDialog}
        onCreateAccount={() => {
          setOpenCreateYourAccountWithInosioDialog(false)
          setOpenCreateAnAccountModalDialog(true)
        }}
        PaymentRequestDetails={PaymentRequestBalanceDetail}
      />
      {/* Enter Bank Account Details */}

      <AddBankAccountModal
        open={openAddBankAccountDialog}
        onContinue={() => {
          setOpenReviewAndSumitDialog(true)
          dispatch({
            type: getfinalprotpdto.type,
          })
        }}
        onBackClick={() => {
          setOpenAddBankAccountDialog(false)
          setOpenPayMethodTypeDialog(true)
        }}
        Fees={PrOtpDto?.FeeAmount ? PrOtpDto?.FeeAmount : 0}
        CompanyName={PaymentRequestBalanceDetail?.CompanyName ?? ''}
      />

      {/* Already Paid */}

      <AlreadyPaidModal
        open={PaymentRequestBalanceDetail?.Status === PaymentRequestStatusType.Completed ? openAlreadyPaidModalDialog : false}
        onLogin={() => {
          setOpenAlreadyPaidModalDialog(false)
          setOpenLoginModelDialog(true)
        }}
        PaymentRequestDetails={PaymentRequestBalanceDetail}
      />

      {/* PR Cancelled */}

      <PRCancelledModal
        open={PaymentRequestBalanceDetail?.Status === PaymentRequestStatusType.Cancelled || isSuccessCancelTransaction ? openPRCancelledModalDialog : false}
        PaymentRequestDetails={PaymentRequestBalanceDetail}
        text={PaymentRequestBalanceDetail?.Status === PaymentRequestStatusType.Cancelled ? 'payment request' : 'payment'}
      />

      {/* New Login Modal */}

      <LoginModal
        open={openLoginModalDialog}
        onBackClick={() => {
          setOpenLoginModelDialog(false)
        }}
        signUp={() => {
          setOpenLoginModelDialog(false)
          setOpenCreateAnAccountModalDialog(true)
        }}
        PaymentRequestDetails={PaymentRequestBalanceDetail}
      />

      {/* Create An Account Modal */}

      <CreateAnAccountModal
        open={openCreateAnAccountModalDialog}
        onBackClick={() => {
          setOpenCreateAnAccountModalDialog(false)
        }}
        iHaveAnAccountClick={() => {
          setOpenCreateAnAccountModalDialog(false)
          setOpenLoginModelDialog(true)
        }}
        PaymentRequestDetails={PaymentRequestBalanceDetail}
      />

      {/* Error Modal  */}

      <ErrorModal
      open={openErrorModal}/>

      {isSpinnerModalOpen ? (
        <SpinnerModal
          isInvisible={true}
          openSpinnerModal={isSpinnerModalOpen}
          spinnerStatus={spinnerStatus}
          handleCloseSpinnerModal={() => {
            if (isSuccessOtp) {
              setThankYouForYourPaymentDialog(true)
            }
            else {
              setIsSpinnerModalOpen(false)
            }
          }
          }
          closeCancel={resetOtpError}
          height={isOnMobileScreen ? "100%" : "563px"}
          width={isOnMobileScreen ? "100%" : "472px"}
        />
      )
        : <></>
      }


      {
        isOnMobileHeight ? <></> : <Grid item sx={{ position: 'absolute', bottom: 50, width: '28%', zIndex: 2000 }} >
          <Divider />
          <Grid item display='flex' justifyContent='center'>
            <span className={classes.forgetText}
              onClick={() => {
                window.open("http://support.inosio.com/");
              }}
            >
              {"Need help?"}
            </span>
          </Grid>
        </Grid>
      }

    </Box >
  );
}
